import 'moment/locale/id';
import * as ExcelJS from 'exceljs';
import moment from 'moment';
import 'moment-duration-format';
import { UserModel } from '../../app/modules/auth/models/UserModel';
import { CustomField, SettingMultiPipelines } from '../../interfaces/Settings';
import { exportWorkbook, setColumnWidths, styleColumns, addWorkSheetInfo, createSingleOptionWorksheets, addNumberFormatting, simpleCustomFieldsMasterProps } from './helperTemplateExcel';
import { createWorkbook } from './helperTemplateExcel';
import { createWorksheet } from './helperTemplateExcel';
import { User } from '../../interfaces/User';
import { Merchant, MultiSimpleMerchant, SimpleMerchant } from '../../interfaces/Merchant';
import { MultiSimpleMeeting, SimpleMeeting } from '../../interfaces/Meeting';
import { MultiSimplePipeline, SimplePipeline } from '../../interfaces/Pipeline';
import { addSingleOptionValidation, getCellNote } from './functionHelperExcel';
import { Label } from '../../interfaces/Label';

interface ExportTemplatePipelineExcelProps {
    nameFile: string,
    customFields: CustomField,
    source: string,
    typeAction: string,
    settings: any,
    nameInfo: string,
    nameHeader: any,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    simpleCustomFieldsMaster: simpleCustomFieldsMasterProps,
    user: UserModel,
    param: any,
    dataMerchants: Merchant[],
    intl: any,
    type?: string,
    isFeatureLabelEnabled: boolean,
    dataLabel: Label[]
    selectMultiPipeline: SettingMultiPipelines
}

export const exportTemplatePipelineExcel = async ({ nameFile, customFields, source, typeAction, settings, nameInfo, nameHeader, setIsLoading, simpleCustomFieldsMaster, user, param, type, dataMerchants, intl, isFeatureLabelEnabled, dataLabel, selectMultiPipeline }: ExportTemplatePipelineExcelProps) => {
    let exportData: any[] = [];
    let exportDataProduct: any[] = [];
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook, "Sheet1");
    const worksheetProduct = createWorksheet(workbook, "Form Produk");
    const worksheetInfo = createWorksheet(workbook, "Info");
    let header: string[] = [];
    let subHeader: string[] = [];
    let headerProduct: string[] = [];
    let subHeaderProduct: string[] = [];
    let singleOptionSheetsPipelines = {};

    header = [...nameHeader.insert.pipeline.header];
    subHeader = [...nameHeader.insert.pipeline.subHeader];

    headerProduct = [...nameHeader.insert.productInPipeline.header];
    subHeaderProduct = [...nameHeader.insert.productInPipeline.subHeader];

    let worksheetUser = workbook.addWorksheet('Daftar User');
    await worksheetUser.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetUser.getCell('A1').value = `Daftar User`;
    await param.dataUsers.forEach((user: any) => {
        worksheetUser.addRow([user.name]);
    });

    let worksheetMerchants = workbook.addWorksheet(`Daftar ${settings.merchant_title ?? 'Merchants'}`);
    await worksheetMerchants.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetMerchants.getCell('A1').value = `Daftar ${settings.merchant_title ?? 'Merchants'}`;
    dataMerchants.forEach((user: any) => {
        worksheetMerchants.addRow([`${user.name} / ${user.phone}`]);
    });

    let worksheetLabel = workbook.addWorksheet('Daftar Label');
    worksheetLabel.getCell('A1').value = `Daftar Label`;
    await dataLabel?.forEach((label: any) => {
        worksheetLabel.addRow([label.name]);
    });


    let worksheetProducts = workbook.addWorksheet('Daftar Produk');
    await worksheetProducts.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetProducts.getCell('A1').value = `Daftar Produk`;
    await param.dataProducts.forEach((user: any) => {
        worksheetProducts.addRow([user.name]);
    });

    let worksheetProgress = workbook.addWorksheet('Daftar Progress');
    await worksheetProgress.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetProgress.getCell('A1').value = `Daftar Progress`;
    await param.dataProgress.forEach((user: any) => {
        worksheetProgress.addRow([user.name]);
    });

    let worksheetSource = workbook.addWorksheet('Daftar Source');
    await worksheetSource.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetSource.getCell('A1').value = `Daftar Source`;
    await param.dataSources.forEach((user: any) => {
        worksheetSource.addRow([user.name]);
    });

    // Daftar Single Option
    singleOptionSheetsPipelines = createSingleOptionWorksheets({ customFields, workbook, simpleCustomFieldsMaster, user: user, intl, source });

    // kalau type nya error akan menambahkan kolom di bawah ini
    if (type === 'error') {
        header.push('Error');
        subHeader.push('Abaikan kolom ini');
        Array.from(param.listErrorInsert).map((row: any, index) => {
            var temp_excel = [];
            temp_excel.push(
                row.pic_name,
                row.merchant_name,
                row.label_name,
                row.progress_name,
                row.source_name,
                row.date_start,
                row.date_end,
                row.note,
                ...Object.keys(customFields).map((field: any) => row[field]),
                row.error
            );
            exportData.push(temp_excel);
        });
    }
    if (type === 'error') {
        headerProduct.push('Error');
        subHeaderProduct.push('Abaikan kolom ini');
        Array.from(param.listErrorInsertProduct).map((row: any, index) => {
            var temp_excel = [];
            temp_excel.push(
                row.pipeline,
                row.name,
                row.hpp,
                row.qty,
                row.price,
                row.discount,
                '',
                row.error
            );
            exportDataProduct.push(temp_excel);
        });
    }

    // Woksheet Form Produk
    worksheetProduct.getRow(1).values = headerProduct;
    worksheetProduct.getRow(2).values = subHeaderProduct;
    setColumnWidths(worksheetProduct, source, headerProduct!, isFeatureLabelEnabled, selectMultiPipeline);
    styleColumns(worksheetProduct, source, 1);
    styleColumns(worksheetProduct, source, 2);
    await addDataRowsProduct(worksheetProduct, workbook, param, user, exportDataProduct, selectMultiPipeline);

    // Protect worksheet Form Product dengan unlock kolom A-F (kecuali G untuk formula Total)
    await worksheetProduct.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    // Woksheet
    worksheet.getRow(1).values = header;
    worksheet.getRow(2).values = subHeader;
    setColumnWidths(worksheet, source, header!, isFeatureLabelEnabled, selectMultiPipeline);
    styleColumns(worksheet, source, 1);
    styleColumns(worksheet, source, 2);
    addDataRows(worksheet, exportData, customFields, source, type!, typeAction, user!, dataMerchants, param, singleOptionSheetsPipelines, simpleCustomFieldsMaster, settings);
    addWorkSheetInfo(worksheetInfo, source, nameFile, nameInfo, nameHeader, user!);

    exportWorkbook(workbook, `${nameFile}.xlsx`, setIsLoading);
};

export const addDataRows = (
    worksheet: ExcelJS.Worksheet,
    data: any[],
    customFields: CustomField,
    source: string,
    type: string,
    typeAction: string,
    user: UserModel,
    dataMerchants: Merchant[],
    param?: any,
    singleOptionSheets?: any,
    simpleCustomFieldsMaster?: {
        pipelines: MultiSimplePipeline
        meetings: MultiSimpleMeeting
        merchants: MultiSimpleMerchant
    },
    settings?: any
) => {
    data.forEach((rowData, index) => {
        worksheet.addRow(rowData);
    });

    for (let i = 3; i <= 3; i++) {
        const cellLabel = worksheet.getCell(`C` + i);
        cellLabel.note = getCellNote('Daftar Label');
    }

    for (let i = 3; i < 550; i++) {
        if (typeAction === 'insert') {
            worksheet.getCell('A' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar User'!$A$2:$A$${param.dataUsers.length === 0 ? 2 : param.dataUsers.length + 1}`],
                errorStyle: 'error',
                error: 'Pilih user',
            };
            worksheet.getCell('B' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar ${settings.merchant_title ?? 'Merchants'}'!$A$2:$A$${dataMerchants.length === 0 ? 2 : dataMerchants.length + 1}`],
                errorStyle: 'error',
                error: `Pilih ${settings.merchant_title ?? 'Merchants'}`,
            };
            worksheet.getCell('D' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Progress'!$A$2:$A$${param.dataProgress.length === 0 ? 2 : param.dataProgress.length + 1}`],
                errorStyle: 'error',
                error: 'Pilih Progress',
            };
            worksheet.getCell('E' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Source'!$A$2:$A$${param.dataSources.length === 0 ? 2 : param.dataSources.length + 1}`],
                errorStyle: 'error',
                error: 'Pilih Source',
            };


            addSingleOptionValidation('I', customFields, singleOptionSheets, typeAction, type, param, worksheet, simpleCustomFieldsMaster);
            addNumberFormatting('I', customFields, typeAction, type, param, worksheet);
        }
    }
};

export const addDataRowsProduct = async (
    worksheet: ExcelJS.Worksheet,
    workbook: ExcelJS.Workbook,
    param: any,
    user: UserModel,
    exportDataProduct: any[],
    selectMultiPipeline: SettingMultiPipelines
) => {
    exportDataProduct?.forEach((row: any, index) => {
        worksheet.addRow(row);
    });

    let worksheetHelper = workbook.addWorksheet('Helper_Data');
    await worksheetHelper.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetHelper.getCell('A1').value = 'PIC / MERCHANT / START DATE';

    for (let i = 2; i <= 549; i++) {
        const rowNum = i + 1;
        worksheetHelper.getCell(`A${i}`).value = {
            formula: `IF(AND(Sheet1!A${rowNum}<>"",Sheet1!B${rowNum}<>"",Sheet1!F${rowNum}<>""),Sheet1!A${rowNum}&" / "&Sheet1!B${rowNum}&" / "&Sheet1!F${rowNum},"")`
        };
    }

    for (let i = 3; i < 550; i++) {
        worksheet.getCell('A' + i).dataValidation = {
            type: 'list',
            allowBlank: false,
            showErrorMessage: true,
            formulae: ['Helper_Data!$A$2:$A$549'],
            errorStyle: 'error',
            error: 'Pilih kombinasi dari data yang sudah diinput di Sheet1',
        };
        worksheet.getCell('B' + i).dataValidation = {
            type: 'list',
            allowBlank: false,
            showErrorMessage: true,
            formulae: [`='Daftar Produk'!$A$2:$A$${param.dataProducts.length === 0 ? 2 : param.dataProducts.length + 1}`],
            errorStyle: 'error',
            error: 'Pilih Produk',
        };

        worksheet.getCell('C' + i).numFmt = selectMultiPipeline.currencyCode === 'IDR' ? '#,##0;-#,##0' : '#,##0.00;-#,##0.00;#,##0';
        worksheet.getCell('D' + i).numFmt = '#,##0;-#,##0'
        worksheet.getCell('E' + i).numFmt = selectMultiPipeline.currencyCode === 'IDR' ? '#,##0;-#,##0' : '#,##0.00;-#,##0.00;#,##0';
        worksheet.getCell('F' + i).numFmt = selectMultiPipeline.currencyCode === 'IDR' ? '#,##0;-#,##0' : '#,##0.00;-#,##0.00;#,##0';

        // Formula untuk kolom G (Total): QTY × Nominal - (QTY × Diskon) jika ada diskon, atau QTY × Nominal jika tidak ada diskon
        worksheet.getCell('G' + i).value = {
            formula: `IF(AND(D${i}<>"",E${i}<>""),IF(F${i}<>"",D${i}*E${i}-D${i}*F${i},D${i}*E${i}),"")`
        };
        worksheet.getCell('G' + i).numFmt = selectMultiPipeline.currencyCode === 'IDR' ? '#,##0;-#,##0' : '#,##0.00;-#,##0.00;#,##0';

        // Unlock kolom A-F untuk editing, kolom G tetap protected karena berisi formula
        worksheet.getCell('A' + i).protection = { locked: false };
        worksheet.getCell('B' + i).protection = { locked: false };
        worksheet.getCell('C' + i).protection = { locked: false };
        worksheet.getCell('D' + i).protection = { locked: false };
        worksheet.getCell('E' + i).protection = { locked: false };
        worksheet.getCell('F' + i).protection = { locked: false };
        // Kolom G (Total) tetap locked (default) untuk melindungi formula
    }


}